import { inject, Injectable, Provider } from '@angular/core'

import { UserProfile } from '@ti/contracts'
import { USER_DIRECTORY_EVENTS } from '@ti/core/contracts/user-directory-events'
import { BaseUserManager } from '@ti/shared/user/services'
import { UserDirectoryKind } from '@ti/shared/user/stores'

@Injectable()
export class AdminUserManager extends BaseUserManager {
  protected readonly userDirectory = UserDirectoryKind.TiAdmin

  protected override readonly updateMessageSummaryKey: string = 'users.updated-message.detail'
  protected override readonly updateMessageDetailKey: string = ''
  protected override readonly deleteMessageSummaryKey: string = 'users.deleted-message.detail'
  protected override readonly deleteMessageDetailKey: string = ''

  public async sendInviteEmail(user: UserProfile) {
    return this.api.ti.user.sendInviteEmail(user.id)
  }

  protected createUser(data: UserProfile) {
    return this.api.ti.user.create(data)
  }

  protected override updateUser(user: UserProfile, data: Partial<UserProfile>): Promise<unknown> {
    return this.api.ti.user.update(user.id, data)
  }

  protected async deleteUser(user: UserProfile) {
    return this.api.ti.user.remove(user.id)
  }

  protected async disableUserMfa(user: UserProfile) {
    return this.api.ti.user.disableMfa(user.id)
  }
}

export const provideAdminUsersManager = (): Provider[] => {
  return [
    AdminUserManager,
    { provide: BaseUserManager, useExisting: AdminUserManager },
    { provide: USER_DIRECTORY_EVENTS, useFactory: () => inject(AdminUserManager).events$ },
  ]
}
